import React from 'react';
import * as PropTypes from 'prop-types';

const H1 = ({ children, fontSize }) => (
  <>
    <h1>{children}</h1>
    <style jsx>
      {`
        h1 {
          font-family: Arial, Helvetica, sans-serif;
          font-weight: normal;
          margin: 0;
          font-size: ${fontSize};
        }
      `}
    </style>
  </>
);

H1.propTypes = {
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.string,
};

H1.defaultProps = {
  fontSize: '32px',
};

export default H1;
